import { FormValidationFn, NoContextFormValidationFn } from '@/models/form';
import { sdk } from '@/utils/sdk';

export const objectNotNullOrUndefinedValidationFn: NoContextFormValidationFn<any> = (input): string | undefined => {
    if (input === null || input === undefined) {
        return sdk.translation.uiTranslation.translate('form.commonErrors.objectNull') as string;
    }
};

export const stringNotEmptyValidationFn: NoContextFormValidationFn<string | undefined> = (input): string | undefined => {
    if (input === null || input === undefined || input.trim() === '') {
        return sdk.translation.uiTranslation.translate('form.commonErrors.stringEmpty') as string;
    }
};

export const numberNotNaNValidationFn: NoContextFormValidationFn<number | undefined> = (input): string | undefined => {
    if (input && isNaN(input)) {
        return sdk.translation.uiTranslation.translate('form.commonErrors.notANumber') as string;
    }
};

export const createStringLengthValidationFn: (lowerBound: number, upperBound: number) => NoContextFormValidationFn<string> = (lowerBound: number, upperBound: number) => {
    return (input): string | undefined => {
        if (input.length > upperBound) {
            return sdk.translation.uiTranslation.translate('form.commonErrors.stringGreaterThan', { bound: upperBound }) as string;
        }

        if (input.length < lowerBound) {
            return sdk.translation.uiTranslation.translate('form.commonErrors.stringLessThan', { bound: lowerBound }) as string;
        }
    };
};

export const arrayNotEmptyValidationFn: NoContextFormValidationFn<any[]> = (input): string | undefined => {
    if (input.length === 0) {
        return sdk.translation.uiTranslation.translate('form.commonErrors.arrayEmpty') as string;
    }
};

export const combineValidationFns = <T, C>(...validationFns: FormValidationFn<T, C>[]): FormValidationFn<T, C> => {
    return (input, context) => {
        for (const validationFn of validationFns) {
            const result = validationFn(input, context);

            if (result) {
                return result;
            }
        }
    };
};
